export class DntEventsListConstantsModel {
  public static readonly filterKey = 'DntEventListFilter';
}
